<template>
    <div class="animation">
        <div class="holder">
            <div class="circle circle1"></div>
            <div class="circle circle2"></div>
            <div class="circle circle3"></div>
            <div class="sparkle1"></div>
            <div class="sparkle2"></div>
            <div class="sparkle3"></div>
            <div class="sparkle4"></div>
            <div class="sparkle5"></div>
            <div class="sparkle6"></div>
            <div class="sparkle7"></div>
            <div class="sparkle8"></div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <g>
                    <path
                        id="key1"
                        d="M13.5,9A5.975,5.975,0,0,0,12,5.036V2.5a2.5,2.5,0,0,0-5,0v.521A6,6,0,0,0,5.5,14.652v.641l-.854.853A.5.5,0,0,0,4.5,16.5a.505.505,0,0,0,.146.354l.854.854v.586l-.854.854a.5.5,0,0,0,0,.707l.854.853V22a.5.5,0,0,0,.146.354l1.5,1.5a.5.5,0,0,0,.708,0l1.5-1.5A.5.5,0,0,0,9.5,22V14.652A6.019,6.019,0,0,0,13.5,9Zm-6-3a1,1,0,1,1-1,1A1,1,0,0,1,7.5,6Zm2-5A1.5,1.5,0,0,1,11,2.5V4.13a5.988,5.988,0,0,0-2-.94V5H8V2.5A1.5,1.5,0,0,1,9.5,1Z"
                    />
                    <path
                        id="key2"
                        d="M22.354,18.026l-5.2-5.2a5.946,5.946,0,0,0-2.123-7.592.5.5,0,0,0-.728.628,7.471,7.471,0,0,1-2.774,9.45.5.5,0,0,0,.269.921h.006a6.023,6.023,0,0,0,2.541-.589l.65.577V17.5a.5.5,0,0,0,.5.5h1.286l.214.224V19.5a.5.5,0,0,0,.5.5h1.119l.917.864a.5.5,0,0,0,.343.136H22a.5.5,0,0,0,.5-.5V18.379A.5.5,0,0,0,22.354,18.026Z"
                    />
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class SuccessIcon extends Vue {}
</script>

<style scoped lang="less">
@keyframes totop {
    from {
        transform: translateY(100px);
        opacity: 0;
    }
    to {
        transform: translateY(0px);
        opacity: 1;
    }
}

@keyframes sparkleAnimation {
    from {
        transform: translateY(200px) scale(0);
        opacity: 0;
    }
    to {
        transform: translateY(0px) scale(1);
        opacity: 1;
    }
}

@keyframes keyAnimation {
    from {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
    }
}

@keyframes scale {
    from {
        transform: translate(-50%, -50%) scale(0);
        opacity: 0;
    }
    to {
        transform: translateY(0px);
        transform: translate(-50%, -50%) scale(1);
    }
}

.holder {
    width: 128px;
    height: 128px;
    margin: 0 auto;
    position: relative;
    animation: totop 1s ease-in-out forwards;
    svg {
        fill: @bright-color;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 69px;
        height: 69px;
        animation: keyAnimation 1s cubic-bezier(0.02, 0.48, 0.36, 0.58) forwards;
        animation-delay: 0.2s;
        opacity: 0;
    }
}
.animation {
    height: 193px;
    display: flex;
    align-items: center;
}
.circle {
    border-radius: 50%;
    position: absolute;
    background-color: @primary-color;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.circle1 {
    width: 193px;
    height: 193px;
    opacity: 0.08;
    animation: scale 1s cubic-bezier(0.02, 0.48, 0.36, 0.58) forwards;
}
.circle2 {
    width: 161px;
    height: 161px;
    opacity: 0.2;
    animation: scale 1s cubic-bezier(0.13, 0.8, 0.3, 0.97) forwards;
}
.circle3 {
    width: 129px;
    height: 129px;
    background-blend-mode: overlay, normal;
    background-image: radial-gradient(
            circle at 37% 20%,
            rgba(255, 255, 255, 0.5),
            rgba(0, 0, 0, 0.5) 80%
        ),
        linear-gradient(to bottom, #00abed, #00abed);
    animation: scale 1s ease-in-out forwards;
}
.sparkle(@size, @posX, @posY, @animationDelay) {
    .circle();
    left: @posX;
    top: @posY;
    opacity: 1;
    background-color: @primary-color-40;
    width: @size;
    height: @size;
    position: relative;
    display: block;
    animation: sparkleAnimation 1s cubic-bezier(0.13, 0.8, 0.3, 0.97) forwards;
    animation-delay: @animationDelay;
    opacity: 0;
    &:before {
        width: calc(@size * 2);
        height: calc(@size * 2);
        content: '';
        background-color: @primary-color-8;
        border-radius: 50%;
        display: block;
        transform: translate(-25%, -25%);
    }
}
.sparkle1 {
    .sparkle(10px, 150px, -40px, 0.7s);
}

.sparkle2 {
    .sparkle(10px, -90px, -15px, 0.5s);
}

.sparkle3 {
    .sparkle(6px, 250px, -25px, 0.2s);
}

.sparkle4 {
    .sparkle(4px, -110px, 40px, 0.7s);
}

.sparkle5 {
    .sparkle(6px, -60px, 90px, 0.3s);
}

.sparkle6 {
    .sparkle(6px, 190px, 20px, 0.4s);
}

.sparkle7 {
    .sparkle(10px, 215px, 50px, 0.4s);
}
.sparkle8 {
    .sparkle(4px, 165px, 70px, 0.4s);
}
</style>
